import React from 'react'

const Home = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-slate-500 text-5xl  font-bold text-white">
      LOGIN TO PLAY WITH TODO APP
    </div>
  );
}

export default Home